import Vue from "vue"
import VueX from 'vuex'

Vue.use(VueX)
 export default new VueX.Store({
     state:{
        order:{},
        totalPrice: 0,
     },
     mutations: {
        updateOrder(state,data){
            // for(let i in data){
            //     state.order[i]=data[i]
            // }
            state.order=data;
        }
     },
     actions:{
        updateOrder(context,data){
            context.commit('updateOrder',data)
        }
     },
     getters: {
        getTotalPrice(state){
            return `$${state.totalPrice>0? state.totalPrice: 0}`
        }
     }
 });
 





// WEBPACK FOOTER //
// ./src/store/index.js